import { useEffect, useState } from 'react';
import CRMService from '../../services/crm.service';
import { formatContactPhone } from './presentation';

export default function MergedRecords({ identityId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    setData(null); setError('');
    if (!identityId) return;
    CRMService.getPersonSources(identityId).then(({ data }) => { if (active) setData(data); })
      .catch(() => { if (active) setError('Unable to load linked records. Reopen this contact to retry.'); });
    return () => { active = false; };
  }, [identityId]);
  if (!identityId) return null;
  if (error) return <p role="alert">{error}</p>;
  if (!data) return null;
  const originals = data.originals || [];
  return <>
    {!!originals.length && !!data.tags?.length && <div className="crm-section">
      <div className="crm-section-title">Tags across linked records</div>
      <div>{data.tags.map(tag => tag.name).join(', ')}</div>
    </div>}
    {!!data.properties?.length && <div className="crm-section">
      <div className="crm-section-title">Properties across linked records</div>
      {data.properties.map(property => <div key={property.rental_id}>{property.name || property.address || property.pms_id}</div>)}
    </div>}
    {!!originals.length && <details className="crm-section">
      <summary>Merged records — original information</summary>
      <p>These are the original values retained when records were combined.</p>
      {(data.sources || []).filter(source => source.source_table === 'guest' && source.record).map(source => <div className="uk-margin-small-top" key={source.source_id}>
        <strong>Linked guest: {source.record.first_name} {source.record.last_name}</strong>
        <div>{source.record.email} {formatContactPhone(source.record.phone || source.record.formatted_phone)}</div>
      </div>)}
      {originals.map((entry, index) => <div key={index}>
        {(entry.records.people || []).map(person => <div className="uk-margin-small-top" key={person.id}>
          <strong>{person.first_name} {person.last_name} — {person.primary_role}</strong>
          <div>{person.email} {formatContactPhone(person.phone)}</div>
          {(entry.records.custom_fields || []).filter(field => String(field.entity_id) === String(person.id)).map(field =>
            <div key={field.id}>{field.label}: {String(field.value_text ?? field.value_number ?? field.value_date ?? field.value_boolean ?? '')}</div>)}
        </div>)}
        {(entry.records.contacts || []).map(person => <div className="uk-margin-small-top" key={person.id}>
          <strong>Original contact: {person.first_name} {person.last_name}</strong>
          <div>{person.email} {formatContactPhone(person.phone || person.formatted_phone)}</div>
          {person.notes && <div style={{ whiteSpace: 'pre-wrap' }}>{person.notes}</div>}
        </div>)}
      </div>)}
    </details>}
  </>;
}
